export default __webpack_public_path__ + "static/media/loanpal_pro_video_desktop@2x.2d15b359.png";